module.exports = __webpack_public_path__ + "img/vue2-renfort_blanc.2d5bce69.png";